type TSmallSpacingValue<T extends number> = T extends -8 | -4 | -2 | 0 | 2 | 4 | 8 ? T : never;

type TLastTwoDigits = `${0 | 2 | 4 | 6 | 8}${0 | 4 | 8}` | `${1 | 3 | 5 | 7 | 9}${2 | 6}`;

type BigMultipleOfFour<T extends number> = `${T}` extends `${string}${TLastTwoDigits}` ? T : never;

type TSpacingValue<T extends number> = TSmallSpacingValue<T> | BigMultipleOfFour<T>;

export const spacer = <T extends number>(pixels: TSpacingValue<T>): `${TSpacingValue<T>}px` =>
  `${pixels}px`;

export const DEFAULT_SPACING = {
  s0: spacer(0),
  s05: spacer(2),
  s1: spacer(4),
  s2: spacer(8),
  s3: spacer(12),
  s4: spacer(16),
  s5: spacer(20),
  s6: spacer(24),
  s7: spacer(28),
  s8: spacer(32),
  s9: spacer(36),
  s10: spacer(40),
  s11: spacer(44),
  s12: spacer(48),
} as const;

export const createSpacing = () => DEFAULT_SPACING;
